<template>
  <div>
  <L1 class="SalesRecord">
    <template slot="slot_title">
      <span>
      <vue-ctk-date-time-picker :range="false" v-model="date" id="dts"
      :color="'var(--color-pri)'"
      :no-label="true"
      :input-size="'sm'"
      :label="'選取時間範圍'"
      :format="'YYYY-MM-DD'"
      :formatted="'YYYY-MM-DD'"
      @input="setDate()"/>
      </span>
      <!-- <button class="addBtn" @click="addProduct=true">新增不分潤商品</button> -->
    </template>
    <div class="boxContent">
    <div class="regular">
      <div :style="{fontSize: '24px', fontWeight: '700'}">POS銷售</div>
      <div><span>凈銷</span><span>{{formatDollarInt(dateData.subtotal)}}</span></div>
      <div><span>折扣(抵用劵)</span><span>{{formatDollarInt(dateData.discount)}}</span></div>
      <div><span>銷售發票總金額(含稅)</span><span>{{formatDollarInt(dateData.total)}}</span></div>
      <div><span>稅</span><span>{{formatDollarInt(dateData.taxtotal)}}</span></div>
      <div><span>稅(內)</span><span>{{formatDollarInt(dateData.tax4)}}</span></div>
      <div><span>稅(外)</span><span>{{formatDollarInt(dateData.tax3)}}</span></div>
      <div><span>稅(合計)</span><span>{{formatDollarInt(dateData.tax1)}}</span></div>
      <div><span>銷售發票總金額(未稅)</span><span>{{formatDollarInt(dateData.untaxed)}}</span></div>
      <template v-for="(mach, m) in dateData.machine">
      <div v-if="mach" :key="`machine-${m}`"><span>MACHINE 0{{m+1}}</span><span>{{mach}}</span></div>
      </template>
      <div><span>總單數</span><span>{{dateData.count}}</span></div>
    </div>
      <div class="coming">
        <div :style="{fontSize: '24px', fontWeight: '700'}">入園統計</div>
      <div v-for="(tic, t) in tickets.filter(e => e.transCategory === '1')" :key="`ticket-${t}`">
        <span>{{tic.productName}}
        </span><span>{{tic.count}}</span><span>{{formatDollarInt(tic.total)}}</span>
      </div>
      <hr>
      <div>
        <span>總入園數</span>
        <span :style="{fontWeight: '900'}">{{tickets.filter(e => e.transCategory === "1").map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <div>
        <span>付費入園數</span>
        <span :style="{fontWeight: '900'}">{{tickets.filter(e => e.transCategory === "1").filter(e => e.currentPrice > 0).map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").filter(e => e.currentPrice > 0).map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <div>
        <span>團體入園數</span>
        <span>{{tickets.filter(e => e.transCategory === "1").filter(e => /團/.test(e.productName)).map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").filter(e => /團/.test(e.productName)).map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <div>
        <span>普通入園數</span>
        <span>{{tickets.filter(e => e.transCategory === "1").filter(e => !/團/.test(e.productName)).map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").filter(e => !/團/.test(e.productName)).map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <div>
        <span>一般 </span>
        <span>{{tickets.filter(e => e.transCategory === "1").filter(e => /一般/.test(e.productName) || /團平/.test(e.productName) || /團假/.test(e.productName)).map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").filter(e => /一般/.test(e.productName) || /團平/.test(e.productName) || /團假/.test(e.productName)).map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <div>
        <span>優待 </span>
        <span>{{tickets.filter(e => e.transCategory === "1").filter(e => /優待/.test(e.productName)).map(e => e.count).reduce((a, b) => a + b, 0)}}</span>
        <span>{{formatDollarInt(tickets.filter(e => e.transCategory === "1").filter(e => /優待/.test(e.productName)).map(e => e.total).reduce((a, b) => a + b, 0))}}</span>
      </div>
      <hr>
      <div v-for="(tic, t) in tickets.filter(e => e.transCategory !== '1')" :key="`ticket45-${t}`">
        <span>{{tic.productName}}
          <span v-if="tic.transCategory==='5'">(沖訂金)</span>
          <span v-else-if="tic.transCategory==='4'">(訂金)</span>
          <span v-else-if="tic.transCategory==='2'">(退貨)</span>
          <span v-else>{{tic.transCategory}}</span>
        </span><span>{{tic.count}}</span><span>{{formatDollarInt(tic.total)}}</span>
      </div>
    </div>
    <div class="parking">
      <div :style="{fontSize: '24px', fontWeight: '700'}">特殊項目</div>
      <div v-for="(tic, t) in parking.filter(e => e.transCategory === '1')" :key="`parking-${t}`">
        <span>{{tic.productName}}
        </span><span :style="{fontWeight: /停車/.test(tic.productName)?'900':'400'}">{{tic.count}}</span><span :style="{fontWeight: /停車/.test(tic.productName)?'900':'400'}">{{tic.total}}</span>
      </div>
      <hr>
      <div v-for="(tic, t) in parking.filter(e => e.transCategory !== '1')" :key="`parking45-${t}`">
        <span>{{tic.productName}}
          <span v-if="tic.transCategory==='5'">(沖訂金)</span>
          <span v-else-if="tic.transCategory==='4'">(訂金)</span>
          <span v-else-if="tic.transCategory==='2'">(退貨)</span>
          <span v-else>{{tic.transCategory}}</span>
        </span><span>{{tic.count}}</span><span>{{tic.total}}</span>
      </div>
    </div>
    </div>
  </L1>
  <!-- <div class="test" :class="totalInfo?'opened':'closed'">
    <div><span>發票總計</span><span>{{formatDollar(total)}}</span></div>
    <div><span>應稅</span><span>{{formatDollar(subtotal)}}</span></div>
    <div><span>稅</span><span>{{formatDollar(taxtotal)}}</span></div>
    <div><span>總單數</span><span>{{records.length}}</span></div>
  </div> -->
  </div>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import { getapi } from '../../store/fetch'
// import charts1 from './partial/chart1'
// import charts2 from './partial/chart2'

export default {
  name: 'SalesRecord3',
  data () {
    return {
      tickets: [],
      parking: [],
      dateData: null,
      date: null
    }
  },
  components: {
    L1
  },
  watch: {
    date () {
      this.getTicketCount()
      this.getParkingCount()
      this.getDateCount()
    }
  },
  created () {
    this.date = this.moment().add(-1, 'day').format('YYYY-MM-DD')
    this.getTicketCount()
    this.getParkingCount()
    this.getDateCount()
  },
  methods: {
    async getTicketCount () {
      if (this.date) {
        this.tickets = await getapi(`consumerecords/ticket?dt=${this.date}`)
      }
    },
    async getParkingCount () {
      if (this.date) {
        this.parking = await getapi(`consumerecords/parking?dt=${this.date}`)
      }
    },
    async getDateCount () {
      if (this.date) {
        this.dateData = await getapi(`consumerecords/date?dt=${this.date}`)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.regular {
  font-size: 20px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
  text-align: start;
  border-radius: 5px;
  padding: 10px 20px;
  color: var(--color-letter);
  line-height: 33px;
  &>div {
    &:hover {
      background-color: var(--color-infobox);
    }
    min-height: 40px;
    display: flex;
    gap: 40px;
    align-items: center;
    justify-content: space-between;
    &>span:nth-child(1) {
      width: 200px;
    }
    &>span:nth-child(2) {
      width: 100px;
      text-align: end;
    }
  }
}
.coming, .parking {
  font-size: 20px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
  text-align: start;
  border-radius: 5px;
  padding: 10px 20px;
  color: var(--color-letter);
  line-height: 33px;
  &>div {
    &:hover {
      background-color: var(--color-infobox);
    }
    min-height: 40px;
    display: flex;
    gap: 40px;
    align-items: center;
    justify-content: space-between;
    &>span:nth-child(1) {
      width: 300px;
    }
    &>span:nth-child(2) {
      width: 70px;
      text-align: end;
    }
    &>span:nth-child(3) {
      width: 100px;
      text-align: end;
    }
  }
}
.boxContent {
  // background-color: var(--color-infobox);
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  height: 100%;
  padding: 50px 20px;
  gap: 20px;
  .chart1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;
    width: calc(100% - 1000px);
  }
}
.tableConsume {
  border-radius: 20px;
  padding: 20px;
  width: 1000px;
  height: fit-content;
  border: 2px solid var(--color-border);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  table tbody {
    overflow-y: auto;
    max-height: 460px;
  }
}
.test.opened {
  position: absolute;
  top: 150px;
  right: 50px;
  font-size: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &>div{
    width: 360px;
    display: flex;
    justify-content: space-between;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  padding: 20px 50px;
  text-align: start;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
}
.test.closed {
  position: absolute;
  top: 15px;
  right: 50px;
  font-size: 26px;
  &>div:nth-child(1) {
    width: 360px;
    display: flex;
    justify-content: space-between;
  }
  &>div:not(:nth-child(1)) {
    display: none;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  padding: 10px 20px;
  text-align: start;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
}
td, th {
  text-align: start;
  padding-inline: 5px;
  box-sizing: border-box;
  // &:nth-child(1) {padding-left: 50px;}
  &:nth-child(1) { width: 120px; }
  &:nth-child(2) { width: 90px; text-align: start; }
  &:nth-child(3) { width: 130px; text-align: end; }
  &:nth-child(4) { width: 120px; text-align: end; }
  &:nth-child(5) { width: 140px; text-align: end; }
  &:nth-child(6) { width: 180px; text-align: end; }
  &:nth-child(7) { width: 90px; text-align: end; }
  &:nth-child(8) { width: 90px; text-align: end;}
}
tr {
  &:not(.detail) span.型態 {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      background-color: var(--預約中);
      color: #FFFFFF;
    }
    &.預購 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
    &.訂金 {
      background-color: var(--已報到);
      color: #FFFFFF;
    }
    &.沖訂金 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
  }
  &.detail span.transCategory{
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      font-weight: bold;
      color: var(--預約中);
    }
    &.退貨 {
      font-weight: bold;
      color: var(--通知付訂);
    }
    &.訂金 {
      font-weight: bold;
      color: var(--已報到);
    }
    &.贈品 {
      font-weight: bold;
      color: var(--已取消);
    }
    &.沖訂金 {
      font-weight: bold;
      color: var(--通知付訂);
      color: #FFFFFF;
    }

  }
}
td:nth-child(8),
td:nth-child(9),
td:nth-child(10) {
  padding-inline: 15px;
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  color: var(--color-letter);
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }
}
.SalesRecord {
  padding-inline: 18px 9px!important;
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  .headtitle {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    letter-spacing: 0.15em;
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
.SalesRecord input[type=radio] {
  min-width: 120px;
  width: 120px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.SalesRecord input[type=date]{
  margin-top: 2px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  width: 215px;
  height: 36px;
  border: 1px solid var(--color-border);
  position: relative;
  padding-inline: 13px;
  box-sizing: border-box;
  &::-webkit-calendar-picker-indicator {
    background: none;
    width: 36px;
    height: 36px;
    mask-image: url(/calendar2.svg);
    position: absolute;
    color: var(--color-checked);
    top: 0;
    right: 0;
    mask-size: contain;
    background-color: var(--color-checked);
    mask-size: 22px;
    mask-repeat: no-repeat;
    mask-position: 8px 5px;
  }
}
</style>
<style lang="scss">
.SalesRecord {
  #dts-wrapper {
    width: 325px;
    height: 40px;
    .field::after {
      content: '';
      position: absolute;
      top: 2px;
      right: 2px;
      width: 36px;
      height: 36px;
      mask-size: contain;
      background-color: var(--color-checked);
      mask-size: 22px;
      mask-repeat: no-repeat;
      mask-position: 8px 6px;
      mask-image: url(/calendar2.svg);
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
  #dts-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    height: 40px!important;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: 325px!important;
  }
}
</style>
